import "../../../styles/styles.scss";
import React from "react";
import { store } from "../../../reducer/Store";
import { Tab, Tabs, Dropdown } from "react-bootstrap";
import PlansList from "./PlansList";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import DetailsPlan from "./DetailsPlan";
import CustomersList from "./CustomersList";
import DetailsCustomersList from "./DetailsCustomersList";
const PlansTrade = () => {
  const { state } = React.useContext(store);
  const [key, setKey] = React.useState("plans-trade");
  const [brand, setBrand] = React.useState();

  const [showDetailsPlan, setShowDetailsPlan] = React.useState(false);
  const [detailsPlan, setDetailsPlan] = React.useState("");
  const [showAddPlan, setShowAddPlan] = React.useState(false);
  const [showDetailsCustomerList, setShowDetailsCustomerList] =
    React.useState(false);
  const [detailsCustomerList, setDetailsCustomerList] = React.useState("");
  const [showAddCustomerList, setShowAddCustomerList] = React.useState(false);

  const [showApplyPlan, setShowApplyPlan] = React.useState(false);

  const handleShowAddPlan = () => {
    if (state.currentBrands.length === 1) {
      setBrand(state.currentBrands[0]);
    }
    setShowAddPlan(true);
  };
  const handleShowAddCustomerList = () => setShowAddCustomerList(true);

  /**
   * Cette fonction permet de gérer la sélection d'un onglet. Elle modifie l'état de showDetailsPlan en fonction de la clé de l'onglet sélectionné.
   * Elle permet également de masquer les détails d'un plan si l'utilisateur sélectionne l'onglet "plans-trade" et de masquer la liste des clients si l'utilisateur sélectionne l'onglet "list-customers".
   * @param {String} key - La clé de l'onglet sélectionné
   */
  function handleSelect(key) {
    // Modifie l'état de showDetailsPlan en fonction de la clé de l'onglet sélectionné
    setKey(key);
    if (key === "plans-trade") {
      setShowDetailsPlan(false);
    }
    if (key === "list-customers") {
      setShowDetailsCustomerList(false);
    }
  }

  React.useEffect(() => {
    //console.log(key);
  }, [key]);

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h1>
            Plans Trade
            {parseInt(localStorage.getItem("user_role")) !== 5 &&
            parseInt(localStorage.getItem("user_role")) !== 6 &&
            key === "plans-trade" &&
            !showDetailsPlan ? (
              <Dropdown className="d-inline-block">
                <Dropdown.Toggle>
                  <MoreVertIcon />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={handleShowAddPlan}
                    disabled={
                      state.currentBrands && state.currentBrands.length === 0
                        ? true
                        : false
                    }
                  >
                    <AddCircleOutlineOutlinedIcon /> Ajouter un plan
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : key === "list-customers" && !showDetailsCustomerList ? (
              <Dropdown className="d-inline-block">
                <Dropdown.Toggle>
                  <MoreVertIcon />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      handleShowAddCustomerList();
                      if (
                        state.currentBrands &&
                        state.currentBrands.length === 1
                      ) {
                        setBrand(state.currentBrands[0]);
                      }
                    }}
                  >
                    <AddCircleOutlineOutlinedIcon /> Ajouter une liste de client
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              ""
            )}
          </h1>
        </div>
      </div>

      <Tabs
        id="tabs-client"
        activeKey={key}
        onSelect={(k) => handleSelect(k)}
        className="mb-3 bg-white"
      >
        <Tab eventKey="plans-trade" title="Liste des plans">
          {!showDetailsPlan ? (
            <PlansList
              refreshTab={key}
              showAdd={showAddPlan}
              setShowAdd={setShowAddPlan}
              setShowDetailsPlan={setShowDetailsPlan}
              setDetailsPlan={setDetailsPlan}
              brand={brand}
              setBrand={setBrand}
            />
          ) : (
            <DetailsPlan
              detailsPlan={detailsPlan}
              showApplyPlan={showApplyPlan}
              setShowApplyPlan={setShowApplyPlan}
            />
          )}
        </Tab>
        {parseInt(localStorage.getItem("user_role")) !== 5 &&
          parseInt(localStorage.getItem("user_role")) !== 6 && (
            <Tab eventKey="list-customers" title="Liste des clients">
              {!showDetailsCustomerList ? (
                <CustomersList
                  refreshTab={key}
                  showAdd={showAddCustomerList}
                  setShowAdd={setShowAddCustomerList}
                  setShowDetailsCustomerList={setShowDetailsCustomerList}
                  setDetailsCustomerList={setDetailsCustomerList}
                />
              ) : (
                <DetailsCustomersList
                  detailsCustomersList={detailsCustomerList}
                />
              )}
            </Tab>
          )}
      </Tabs>
    </>
  );
};
export default PlansTrade;
